<template>
  <div class="card" ref="container">
    <vue-tailwind-color-picker
      v-if="isReady"
      :value="normalizedValue"
      :hide-swatches="hideSwatches"
      :swatches.sync="swatches"
      @input="(value) => $emit('input', value)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isReady: false,
    };
  },
  props: {
    value: {
      type: String,
      default: "#FFFFFF00",
    },
    swatches: {
      type: Array,
      default: () => [
        "#f94144",
        "#f3722c",
        "#f8961e",
        "#f9c74f",
        "#90be6d",
        "#43aa8b",
        "#577590",
        "#22223b",
        "#4a4e69",
        "#c9ada7",
      ],
    },
    hideSwatches: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    normalizedValue() {
      return this.value || "#FFFFFFFF";
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.requestAnimationFrame(() => {
        if (this.$refs.container) {
          this.isReady = true;
        }
      });
    });
  },
};
</script>
